import { Component, OnInit, Input, ViewChild, ElementRef, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeServiceService } from 'src/app/services/change-service.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { MANAGE_LINE_CONST, COMMON_CONSTANTS, ANALYTICS, ENTITLEMENT_ACTIVITYNAMES } from '../../../common/core/common.constants';
import { each } from 'lodash';
import { UtilsService } from 'src/app/services/utils.service';
import { DataSharingService } from 'src/app/services/data-sharing.service';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { ConflictingModalComponent } from '../../../shared/components/conflicting-modal/conflicting-modal.component';
import { environment } from 'src/environments/environment';
import { PDLService } from 'src/app/services/pdl-service.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { WindowServiceService } from 'src/app/services/window-service.service';
import { TransactionsModalComponent } from 'src/app/manage-lines/components/transactions-modal/transactions-modal.component';

import { PartnerSubscriptionRedemptionPopupModalComponent } from 'src/app/shared/components/partner-subscription-redemption-popup-modal/partner-subscription-redemption-popup-modal.component';
import { LoaderService } from 'src/app/services/loader.service';
import { EntitlementService } from 'src/app/services/entitlement.service';
import { BasicPopupModalComponent } from 'src/app/shared/components/basic-popup-modal/basic-popup-modal.component';


@Component({
  selector: 'app-changeservices-sticky-footer',
  templateUrl: './changeservices-sticky-footer.component.html',
  styleUrls: ['./changeservices-sticky-footer.component.scss']
})
export class ChangeservicesStickyFooterComponent implements OnInit {
  @Input() isServiceChanged;
  @Input() previousServicesTotal;
  @Input() currentServicesTotal;
  @Input() subscriberData;
  @Input() ratePlansAddedList;
  @Input() ratePlansRemovedList;
  @Input() servicesList;
  @Input() currentSelectedServices;

  retry = false;
  submitResponse: any;
  isReviewPage = false;
  lastIndexString: any;
  servicesListCurrentState = [];
  authoringContentData: any;
  serviceTerms: {};
  termsAndConditionsData: {};
  showTechnicalIssuePopup: any;
  public addedServArray = [];
  public removedServArray = [];
  ngbModalOptions: NgbModalOptions;
  private isk2kEnabled = environment.ENABLE_K2K_SOCS_FLOW;
  private restrictedByk2kSocs = false;
  isSubmitReadOnly: boolean;
  
  idpType: any;

  @ViewChild('transactionError') transactionError: ElementRef;
  _router: Router;
  _cacheSvc: HttpCacheService;
  _utilsSvc: UtilsService;
  dataSharingSvc: DataSharingService;
  _changeSvc: ChangeServiceService;
  modalService: NgbModal;
  utilsSvc: UtilsService;
  pdlService: PDLService;
  _windowService: WindowServiceService;
  _loaderSvc: LoaderService;
  entitlementSvc: EntitlementService;
  userHasNetflixRedemptionActivity: any;
  netflixPartnerLoadingTimeout: number =  COMMON_CONSTANTS.NETFLIX_PARTNER_LOADING_TIMEOUT;

  constructor(private injector : Injector
) {this._router = this.injector.get<Router>(Router);
  this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
  this._utilsSvc = this.injector.get<UtilsService>(UtilsService);
  this.dataSharingSvc = this.injector.get<DataSharingService>(DataSharingService);
  this._changeSvc = this.injector.get<ChangeServiceService>(ChangeServiceService);
  this.modalService = this.injector.get<NgbModal>(NgbModal);
  this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
  this.pdlService = this.injector.get<PDLService>(PDLService);
  this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
  this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
  this.entitlementSvc = this.injector.get<EntitlementService>(EntitlementService); }

  ngOnInit() {
    this.idpType = this._cacheSvc.getFromSessionStorage('IDPType');
    this.userHasNetflixRedemptionActivity = this.entitlementSvc.getEntitlementActivityflag(ENTITLEMENT_ACTIVITYNAMES.PARTNER_SUBSCRIPTION_REDEMPTION, 0);
    this.checkIfReviewPage();
    this.ngbModalOptions =  {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    this.subscriberData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_DATA));
    this.servicesListCurrentState = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.SERVICES_LIST_CURRENT_STATE));
    this.authoringContentData = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.CONTENT));
    this.dataSharingSvc.currentDataGeneric.subscribe(data => {
      if (data) {
        if (data.has(COMMON_CONSTANTS.SERVICE_AGREEMENT_DATA)) {
          this.serviceTerms = data.get(COMMON_CONSTANTS.SERVICE_AGREEMENT_DATA);
        }
        if (data.has(COMMON_CONSTANTS.TERMS_CONDITIONS_DATA)) {
          this.termsAndConditionsData = data.get(COMMON_CONSTANTS.TERMS_CONDITIONS_DATA);
        }
      }
    });
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };

    this.isSubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_SINGLE);
  }

  public checkIfReviewPage() {
    const url = this._windowService.location.href.split('/');
    this.lastIndexString = (url.splice(url.length - 1, 1, COMMON_CONSTANTS.SERVICES.REVIEW_CHANGE_SERVICE));
    this.isReviewPage = this.lastIndexString.toString() === COMMON_CONSTANTS.SERVICES.REVIEW_CHANGE_SERVICE;
  }

  goToReviewPage() {
    const ban = this._cacheSvc.getFromSessionStorage('ban');
    const msisdn = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN));
    const requestBody = {
      'billingAccount': ban,
      'level': COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER,
      'mobileNumber': String(msisdn)
    };

    this._changeSvc.getPlanChangeEffectiveDate(requestBody).subscribe(response => {
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.SERVICES.REVIEW_CHANGE_SERVICE_DATA, JSON.stringify(response));
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.SERVICES.CURRENT_SELECTED_SERVICES, JSON.stringify(this.currentSelectedServices));
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.SERVICES.CURRENT_SERVICES_TOTAL, JSON.stringify(this.currentServicesTotal));
      this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_CHANGE_S_REVIEW]);
    }, error => {
      this._utilsSvc.errorHandling(error);
    });
  }

  goToChangeServicesPage() {
    this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_CHANGE_SERVICE]);
  }

  goToServicesConfirmationPage() {
    this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_CHANGE_S_CONFIRMATION]);
  }

  checkRemoveK2KServices() {
    this.restrictedByk2kSocs = false;
    each(this.servicesList, (service) => {
      if ((service.isk2k && (!service.isNFLX || !service.isHULU)) && !service.currentService && service.isSelected) {
        this.openConflictModelK2k(service , COMMON_CONSTANTS.SERVICES.ADDITION);
      }
      if ((service.isk2k || (service.isNFLX || service.isHULU)) && service.currentService && (!service.isSelected)) {
        this.openConflictModelK2k(service , COMMON_CONSTANTS.SERVICES.REMOVAL);
      }
    });
  }

  openConflictModelK2k(service , type) {
    this.restrictedByk2kSocs = true;
    const conflictingModalRef = this.modalService.open(ConflictingModalComponent, this.ngbModalOptions);
    conflictingModalRef.componentInstance.servicesList = this.servicesList;
    conflictingModalRef.componentInstance.currentSelectedServices = this.currentSelectedServices;
    conflictingModalRef.componentInstance.selectedService = service;
    conflictingModalRef.componentInstance.k2kPopUp = true;
    conflictingModalRef.componentInstance.restrictedInReviewTyp = type;
  }

  submitServiceChanges() {
    if (this.isk2kEnabled) {
      this.checkRemoveK2KServices();
    }
    if (!this.restrictedByk2kSocs){
      if (this.isReviewPage) {
        this._changeSvc.submitServices(this.ratePlansAddedList, this.ratePlansRemovedList).subscribe(response => {
          this._loaderSvc.start();
          this.submitResponse = response;
          this.callsWhenStatusNotSuccess(response);
        }, error => {
          if(environment.ENABLE_BUSINESS_INTERNET && error.error?.error?.[0]?.code === COMMON_CONSTANTS.SUBMIT_ERROR_CODE_BI) {
            const transactionsModallRef = this.modalService.open(TransactionsModalComponent, this.ngbModalOptions);
            transactionsModallRef.componentInstance.showTransactionsModalPopup = true;
          }else {
            this.submitServiceError();
          }
          this._loaderSvc.stop();
        });
      } else {
        this.goToReviewPage();
      }
    }

    let clickEventInfo = this.getSubmitSvcsChangeTagInfo();
    this.pdlService.ifEnabledGenerateClickTag(clickEventInfo);
  }

  callsWhenStatusNotSuccess(response){
    this._loaderSvc.stop();
    if (this.submitResponse.status !== MANAGE_LINE_CONST.SUCCESS) {
      this.submitServiceError();
      this.retry = true;
    }
    else {
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.ORDER_ID, response.changeRequestOrderId);
      this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_CHANGE_S_CONFIRMATION]);
      if(this.ratePlansAddedList.length !== COMMON_CONSTANTS.DIGITS.ZERO && environment.ENABLE_PARTNER_SUBSCRIPTION_REDEMPTION) {
        this.hasRedemptionSOCAndRedirect(response);
      }
    }
  }

  hasRedemptionSOCAndRedirect(submitPlanChangeResponse) {
    let redemptionSocs: any = { isNetFlixSoc: false, isHuluSoc: false };
    this.ratePlansAddedList.forEach(service => {
      if (service.socIndicator === COMMON_CONSTANTS.NETFLIX_SOC_INDICATOR) {
        redemptionSocs.isNetFlixSoc = true;
      }
      if (service.socIndicator === COMMON_CONSTANTS.HULU_SOC_INDICATOR) {
        redemptionSocs.isHuluSoc = true;
      }
    });
    if(Object.values(redemptionSocs).some(value => value === true) && submitPlanChangeResponse.status.toLowerCase() === COMMON_CONSTANTS.ALERT_TYPES.SUCCESS.toLowerCase()) {
      // API call -> Success -> Redirection Link ->  Popup
      this.redemtionPopupRedirect(redemptionSocs);
    }
  }

  redemtionPopupRedirect(redemptionSocs) {
    if (this.idpType === COMMON_CONSTANTS.AZURE_KEY) {
      this.openCareRedemptionReminderPopup(redemptionSocs);
    } else if(this.idpType === COMMON_CONSTANTS.IAM_KEY && this.userHasNetflixRedemptionActivity) {
      let msisdn = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN);
      this._loaderSvc.startWithLoadingTexts(COMMON_CONSTANTS.NETFLIX_PARTNER_LOADING_TEXTS);
      setTimeout(() => {
      this._changeSvc.getPartnerRedirectionLink(msisdn, redemptionSocs).subscribe(response => {
        if(!isNullOrUndefined(response) && response?.isEligible) {
          this.openRedemptionRedirectionPopup(response, redemptionSocs);
        } else {
          this.openInEligibleErrorPopup(response);
        }
        this._loaderSvc.stop();
      }, error => {
        this._loaderSvc.stop();
        this._utilsSvc.errorHandling(error);
      });
    }, this.netflixPartnerLoadingTimeout);
    }
  }

  openInEligibleErrorPopup(response: any) {
    const popupRef = this.modalService.open(BasicPopupModalComponent, {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    });
    popupRef.componentInstance.title = this.authoringContentData.manageLinePlansandServices.snagHeader;
    popupRef.componentInstance.message = this.authoringContentData.manageLinePlansandServices.errorMessageBodyTxt;
  }

  openRedemptionRedirectionPopup(response, redemptionSocs) {
    const popupRef = this.modalService.open(PartnerSubscriptionRedemptionPopupModalComponent, {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    });
    popupRef.componentInstance.isRegistered = response.isRegistered;
    popupRef.componentInstance.enableRedirection = true;
    popupRef.componentInstance.redirectionLink = response.redirectionLink;
    popupRef.componentInstance.isHuluSoc = redemptionSocs.isHuluSoc;
    popupRef.componentInstance.isNetFlixSoc = redemptionSocs.isNetFlixSoc;
  }

  openCareRedemptionReminderPopup(redemptionSocs) {
    const popupRef = this.modalService.open(PartnerSubscriptionRedemptionPopupModalComponent, {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    });
    popupRef.componentInstance.isRegistered = false;
    popupRef.componentInstance.enableRedirection = false;
    popupRef.componentInstance.isHuluSoc = redemptionSocs.isHuluSoc;
    popupRef.componentInstance.isNetFlixSoc = redemptionSocs.isNetFlixSoc;
  }

  getSubmitSvcsChangeTagInfo() {
    let addedServicesfromStorage = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.ADDED_SERVICES));
    let currentSelection: any = [];
    if(!isNullOrUndefined(addedServicesfromStorage)){
      for (let count = COMMON_CONSTANTS.DIGITS.ZERO; count < addedServicesfromStorage.length; count++) {
        currentSelection.push(addedServicesfromStorage[count].name);
      }
    }
    let submitCTAName = this.authoringContentData.changeStickyFooter.reviewChangesTxt;
    if(this.isReviewPage){
      submitCTAName= this.authoringContentData.changeStickyFooter.submitChangesTxt;
    }

    return {
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: submitCTAName,
      assetType: ANALYTICS.BUTTON,
      modalName:'',
      userSelection:currentSelection
    };
  }

  submitServiceError() {
    this.modalService.open(this.transactionError, this.ngbModalOptions);
  }

  close() {
    this.modalService.dismissAll();
  }

}
